export default __webpack_public_path__ + "img/5690e962d75f594e236f3d58ce0456b0.svg";